<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button class="button" slot="trigger" @click.stop>
        {{ name }}
      </button>
    </template>

    <b-dropdown-item aria-role="listitem">
      {{ $t("accesses.merchantAccess") }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: ["name"]
};
</script>
